<template>
  <div class="documents">
    <file-uploader @select="selectFiles" :accept="fileTypes">
      <b-row>
        <b-col>
          <b-table
            class="condensed"
            striped
            hover
            responsive
            :items="documents"
            :fields="fields"
            show-empty
            @row-clicked="downloadFile"
          >
            <template slot="preview" slot-scope="data">
              <DocumentsPreview :document="data.item"></DocumentsPreview>
            </template>
            <template slot="commands" slot-scope="data">
              <b-button size="sm" variant="danger" @click="onDelete(data.item)">
                <i class="fa fa-trash"></i>
              </b-button>
            </template>
            <template slot="empty">
              <h5 class="text-center text-muted mt-2">No documents found</h5>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </file-uploader>
  </div>
</template>

<script>

import { documentsFields } from './Documents.fields';

export default {
  props: [
    'fileTypes',
    'service',
    'parentId'
  ],
  data() {
    return {
      documents: [],
      fields: documentsFields,
    }
  },
  methods: {
    async selectFiles(files) {
      await this.service.uploadFiles(this.parentId, files);
      await this.reloadDocuments();
    },
    async onDelete(document) {
      const result = await this.$bvModal.msgBoxConfirm(`Are you sure you want to delete "${document.filename}"?`, {
        size: 'md',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'Cancel',
        centered: true,
        scrollable: true,
      })
      if (result) {
        await this.service.deleteDocument(document.id);
        await this.reloadDocuments();
      }
    },
    async reloadDocuments() {
      this.documents = await this.service.getAll(this.parentId)
    },
    async downloadFile(file) {
      await this.service.openDocument(file);
    }
  },
  async mounted() {
    await this.reloadDocuments();
  }
}
</script>

<style lang="scss">
.company--documents-tab {
  table {
    margin-top: 1rem;
    td {
      cursor: pointer;
    }
  }
}
</style>
